import React from "react";

export default function NewYearFrame9({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-9ne5{fill:none;stroke:#f04f26;stroke-miterlimit:10}.cls-9ne2{fill:#003f2e}.cls-9ne4{fill:#eafefe}.cls-9ne5{stroke-width:20px}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_5"
          data-name="\u0421\u043B\u043E\u0439 5"
        >
          <path
            d="M1176 461.87c12.5-40 54.61-61.31 90.08-50.18 38.42 12.05 60.79 59.5 41.92 101.05"
            style={{
              strokeWidth: "21.66px",
              fill: "none",
              stroke: "#f04f26",
              strokeMiterlimit: 10,
            }}
          />
          <path
            d="M1289.36 719a545.49 545.49 0 0 0-237.72-92.51l48.8-124.42a72 72 0 0 1 84.3-44 507.57 507.57 0 0 1 119.72 46.09 72.1 72.1 0 0 1 33.26 89.39Z"
            className="cls-9ne2"
          />
          <path
            d="M1507.56 1311.52a529.83 529.83 0 0 1-23.46 52.42c-5.15 10.23-10.69 20.18-16.49 29.88a496.29 496.29 0 0 1-29.88 44.9c-6.39 8.84-13.16 17.38-20.2 25.69a491.32 491.32 0 0 1-35.26 38.21c-4.07 4.11-8.33 8.15-12.62 12.11a534.87 534.87 0 0 1-79.77 60.78q-10 6.27-20.2 12a542.71 542.71 0 0 1-97.14 43c-1.23.45-2.47.89-3.68 1.28a540.58 540.58 0 0 1-635.37-246.1c-2.92-5-5.67-10-8.39-15.1a543 543 0 0 1-61.34-207.94q-2.17-25.35-1.87-51a529.22 529.22 0 0 1 11.49-105.42q4.55-22 11.13-43.81c3.95-13.4 8.49-26.64 13.59-39.88q8.37-21.72 18.42-42.28 8.61-17.89 18.44-34.75c6.13-10.57 12.52-20.89 19.28-30.86.68-1 1.35-2 2.07-3a516.84 516.84 0 0 1 46.29-58.55c2.54-2.92 5.24-5.86 8-8.63 10.14-10.81 20.77-21.06 31.71-30.84q13.92-12.33 28.46-23.71c1.63-1.29 3.24-2.51 4.91-3.72a541.29 541.29 0 0 1 113.06-65.85 528.19 528.19 0 0 1 89.37-29.66 541.8 541.8 0 0 1 659.18 442.43 555.08 555.08 0 0 1 6.52 73.07 542.08 542.08 0 0 1-4.65 81.76q-3.14 23.63-8.47 47.26c-2.57 11.65-5.63 23.26-9.07 34.8-1 3.25-1.94 6.5-3 9.78-3.28 10.64-7.01 21.21-11.06 31.73Z"
            style={{
              fill: "#f04f26",
            }}
          />
          <path
            d="M1518.63 1279.83a4709.44 4709.44 0 0 1-436.39-360.13q-24.54-22.87-48.73-46.13-60.13-57.71-118.38-117.8-64.5-66.32-126.38-135.38a528.19 528.19 0 0 1 89.37-29.66q95.8 105.14 197.86 204c21.49 20.93 43.19 41.51 65.08 62q27.59 25.76 55.76 51.11c109.36 98.63 224 192.46 342.35 280.2q-3.14 23.63-8.47 47.26c-2.57 11.65-5.63 23.26-9.07 34.8-.97 3.2-1.94 6.45-3 9.73ZM1484.1 1363.94c-5.15 10.23-10.69 20.18-16.49 29.88a496.29 496.29 0 0 1-29.88 44.9q-39.72-14.45-79.17-29.65-43.79-16.87-87.26-34.62c-106-43.27-210.54-90.5-312.64-141.21a4723.67 4723.67 0 0 1-474.15-270.81c3.95-13.4 8.49-26.64 13.59-39.88q8.37-21.72 18.42-42.28c119.11 78.29 242.42 151.24 368.32 218.16Q940.6 1128 997 1156.07c102.51 50.93 207.5 98.21 314.1 141.49q85.96 34.94 173 66.38ZM1269.68 1587.55a542.71 542.71 0 0 1-97.14 43q-92.51-55-182.44-114.35-96.35-63.35-189-131.24c-4.49-3.29-9-6.58-13.43-9.94-112.14-82.57-221.12-170.74-325.76-263.36a529.22 529.22 0 0 1 11.49-105.42A4624 4624 0 0 0 852 1315.4q84.78 62.08 172.87 120.4 101.91 67.73 207.51 129.9c12.39 7.42 24.79 14.68 37.3 21.85Z"
            className="cls-9ne4"
          />
          <path
            d="M1382.27 1502.62c-4.07 4.11-8.33 8.15-12.62 12.11a534.87 534.87 0 0 1-79.77 60.78q-28.8-4.6-57.53-9.81-121.86-21.48-242.25-49.5-73.71-17-146.57-36.37-156.12-41.5-310-94.1c-2.92-5-5.67-10-8.39-15.1a536.34 536.34 0 0 1-38.67-92.7q149 53.67 301.22 97.09 39 11.18 78 21.54 79.07 21.09 159.17 39.24c118.14 26.97 237.6 49.35 357.41 66.82ZM1519.8 958c-108.18-13-216.13-29.71-323-50.21q-65.13-12.4-129.63-26.64c-11.26-2.5-22.44-5-33.68-7.58a4709.329 4709.329 0 0 1-404.91-111.91l-26-8.52c2.54-2.92 5.24-5.86 8-8.63 10.14-10.81 20.77-21.06 31.71-30.84q13.92-12.33 28.46-23.71c1.63-1.29 3.24-2.51 4.91-3.72q118.68 38.06 239.44 69.53 80.16 21 160.85 39c3.26.76 6.52 1.52 9.8 2.22 130.56 28.85 263.14 52.08 396.35 69.45a538.33 538.33 0 0 1 37.7 91.56Z"
            className="cls-9ne2"
          />
          <path
            d="M1467.61 1393.82a496.29 496.29 0 0 1-29.88 44.9c-6.39 8.84-13.16 17.38-20.2 25.69q-73.8-43.58-146.23-90c-108-69.2-213.37-142.9-314.92-220.32q-36-27.41-71.54-55.7a4654.05 4654.05 0 0 1-328.53-286.74 516.84 516.84 0 0 1 46.29-58.55c2.54-2.92 5.24-5.86 8-8.63 5.95 5.77 12 11.51 18 17.15a4611 4611 0 0 0 380.07 323.94c97.57 74.47 198.72 145.35 302.44 212q77.37 49.74 156.5 96.26Z"
            className="cls-9ne2"
          />
          <path
            d="M1280.55 406.58c-18.43-48.06-99.62-252.81-175.21-243.06-36 4.64-64.39 57.18-66.38 100.08-3.3 70.85 65.11 120.11 109.62 138.5 58.73 24.26 113.26 10.22 131.97 4.48Z"
            className="cls-9ne5"
          />
          <path
            d="M1274.22 410.47c33.9-117 111.28-192.12 184.12-190.64 33.76.68 71.62 17.91 84.76 43.57 24.15 47.14-38.88 115.41-107.69 142.59-70.41 27.83-140.87 10.22-161.19 4.48Z"
            className="cls-9ne5"
          />
          <path
            d="M1279.09 415.86c-19-120.36 19.23-221.19 85.81-250.76 30.86-13.71 72.46-14.17 95.25 3.49 41.86 32.44 13.76 121-37 174.81-51.98 55.09-123.23 69.04-144.06 72.46Z"
            style={{
              strokeWidth: 15,
              fill: "none",
              stroke: "#f04f26",
              strokeMiterlimit: 10,
            }}
          />
          <rect
            width={750.34}
            height={750.34}
            x={622.61}
            y={744.51}
            className="cls-9ne4"
            rx={149.21}
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
